module.exports = __webpack_public_path__ + "static/media/rcp.5388811d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rcp.jpg
// module id = 985
// module chunks = 0